import { useMemo } from 'react';

import { useGrid } from '@Components/Grid';
import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, deleteAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';
import { useSelectOptions } from '@Stores/base-factories/store-list';

import ContestsFinished from './ContestsFinished';
import DuplicateEntity from './DuplicatedEntity';
import ProgressBarFormatter from './ProgressBarFormatter';
import ReportLink from './ReportLink';

export default function useColumns() {
  const { store: { lists: { sites: { items, useLoad } } } } = useGrid()
  const sites = useSelectOptions({ useLoad, items })

  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('description', 'Description', info => <NameAndCreateDateFormatter info={info} />, { initialSize: 'max-w-[20vw]' }),
    column.accessor('sentToday', {
      header: 'Sent Today',
      cell: info => <ProgressBarFormatter info={info} />,
      enableSorting: false,
      enableColumnResize: false,
    }),
    defaultColumn('integration_type', 'Type', undefined, { enableTruncate: true }),
    defaultColumn('vendor', undefined, undefined, { enableTruncate: true }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateAction(sites), reportLinkAction, contestsFinishedAction),
  ], [sites])
}

const duplicateAction = sites => info => <DuplicateEntity key={keyOf(info, 'duplicate')} info={info} sites={sites} />

function reportLinkAction(info) {
  return <ReportLink key={keyOf(info, 'report-link')} info={info} />
}

function contestsFinishedAction(info) {
  return <ContestsFinished key={keyOf(info, 'contests-finished')} info={info} />
}
